import { render, staticRenderFns } from "./importDetailCompany.vue?vue&type=template&id=7a063e4c&scoped=true&"
import script from "./importDetailCompany.vue?vue&type=script&lang=js&"
export * from "./importDetailCompany.vue?vue&type=script&lang=js&"
import style0 from "./importDetailCompany.vue?vue&type=style&index=0&id=7a063e4c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a063e4c",
  null
  
)

export default component.exports